import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Tasks from "./pages/Tasks";
import Users from "./pages/Users";
import Accounts from "./pages/Accounts";
import Agents from "./pages/Agents";
import Apis from "./pages/Apis";
import Permissions from "./pages/Permissions";
import Cost from "./pages/Cost";
import UserSection from "./pages/UserSection";
import Content from "./pages/Content";
import Adoption from "./pages/Adoption";
import Placeholder from "./pages/Placeholder";
import { Toaster } from "./components/ui/sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  // Detect OAuth redirect SYNCHRONOUSLY during render to avoid race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/dashboard"   element={<Dashboard />} />
        <Route path="/tasks"       element={<Tasks />} />
        <Route path="/tasks/:tab"  element={<Tasks />} />
        <Route path="/agent"       element={<Agents />} />
        <Route path="/agent/:tab"  element={<Agents />} />
        <Route path="/integrations" element={<Apis />} />
        <Route path="/permissions" element={<Permissions />} />
        <Route path="/cost"        element={<Cost />} />
        <Route path="/adoption"    element={<Adoption />} />
        <Route path="/content"     element={<Content />} />
        <Route path="/users"       element={<Users />} />
        <Route path="/accounts"    element={<Accounts />} />
        <Route path="/user-section" element={<UserSection />} />
      </Route>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
